import React from 'react';
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { Alert } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import LegacyUserDbqEditor from './LegacyUserDbqEditor';
import UserDbqEditorRequestFlow from './UserDbqEditorRequestFlow';

const UserDbqEditor = () => {
  const { userDbqId } = useParams();

  const { data, isLoading, error } = useQuery({
    queryKey: ['userDbq', userDbqId],
    queryFn: async () => {
      const response = await axios.get(`/dbq/user-dbq/${userDbqId}`);
      return response.data;
    },
    enabled: Boolean(userDbqId),
    refetchOnWindowFocus: false,
  });

  if (isLoading && !data) {
    return (
      <div className="dbq-renderer">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
          <div className="text-center">
            <FontAwesomeIcon icon={faSpinner} spin size="3x" className="text-primary mb-3" />
            <p className="text-muted">Loading form...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error && !data) {
    return (
      <div className="dbq-renderer">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
          <Alert variant="danger">
            <strong>Error:</strong> Failed to load form. {error?.response?.data?.msg || error?.message}
          </Alert>
        </div>
      </div>
    );
  }

  if (data?.dbqRequestFlowEnabled) {
    return <UserDbqEditorRequestFlow />;
  }

  return <LegacyUserDbqEditor />;
};

export default UserDbqEditor;
